/**
 * Get expiration date in GMT format given an amount of days
 * @param {Number} days - Amount of days
 * @returns {String} - Date in GMT format
 */

export const useCookies = () => {
  const getExpirationDate = (days) => {
    if (!days) {
      return
    }
    
    const date = new Date()
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
    return date.toGMTString()
  }

  /**
   * Set cookie
   * @param {String} name - Cookie name
   * @param {String} value - Cookie value
   * @param {Number} days - Amount of days where the cookie is valid
   * @param {Boolean} encode - encode the cookie value
   * @param {Boolean} skipDomain - will set the cookie on the full domain name www.adyen.com
   */
  const setCookie = (name, value, days?, encode = true, skipDomain = false) => {
    if (!name) {
      return
    }
    const domainRegex = /\.+[^.]+\.+[^.]*$/g // www.adyen.com => .adyen.com

    // if the deploy environment is production we set secure cookies
    const domain = process.env.isProd
      ? skipDomain
        ? '; path=/; secure'
        : `; domain=${domainRegex.exec(document.domain)?.[0]}; path=/; secure`
      : '; path=/;'

    const expires = days ? `; expires=${getExpirationDate(days)}` : ''
    document.cookie = `${encodeURIComponent(name)}=${encode ? encodeURIComponent(value) : value}${expires}${domain}`
  }

  /**
   * Unset/remove the cookie that matches the given name
   * @param {String} name - Cookie name
   */
  const unsetCookie = (name) => setCookie(name, '', -1)

  /**
   * Get the value of the cookie that matches the given name
   * @param {String} name - Cookie name
   * @returns {String|null} - Cookie value
   */
  const getCookie = (name) => {
    const nameEQ = `${encodeURIComponent(name)}=`
    const ca = document.cookie.split(';')
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i]
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length)
      }
      if (c.indexOf(nameEQ) === 0) {
        return decodeURIComponent(c.substring(nameEQ.length, c.length))
      }
    }
    return null
  }

  return {
    getCookie,
    setCookie,
    unsetCookie,
    getExpirationDate
  }
}
